
export const hasAnyRequiredGroup = (
  userGroups: string[] | undefined,
  requiredGroups?: string[]
): boolean => {
  if (!requiredGroups || requiredGroups.length === 0) return true

  if (!userGroups || userGroups.length === 0) return false

  return requiredGroups.some((group) => userGroups.includes(group))
}
